import { toNumber } from 'lodash-es';
import {
  USER_AGENT_AOS_VERSION_REG_EX,
  USER_AGENT_IOS_VERSION_REG_EX,
} from './../constants/webapp';
import { NextApiRequest, NextApiResponse } from 'next';
import { AnyAction, Dispatch } from 'redux';
import {
  GPS_LATITUDE_MIN,
  GPS_LATITUDE_MAX,
  GPS_LONGITUDE_MIN,
  GPS_LONGITUDE_MAX,
  GPS_DEFAULT_LATITUDE,
  GPS_DEFAULT_LONGITUDE,
  USER_AGENT_AOS_REG_EX,
  USER_AGENT_IOS_REG_EX,
  WEBAPP_TYPE_AOS,
  WEBAPP_TYPE_IOS,
  WEBAPP_TYPE_WEB,
} from '@/constants';
import { WebAppType } from '@/types';
import { init } from '@/redux/reducers/webapp';

class WebAppService {
  constructor(
    private readonly req?: NextApiRequest,
    private readonly res?: NextApiResponse,
    private readonly dispatch?: Dispatch<AnyAction>,
  ) {}

  identify() {
    const userAgent = this.req?.headers['user-agent'] || 'unknown';
    const webAppType = this.getWebAppInfo(userAgent);

    if (this.dispatch) {
      this.dispatch(init(webAppType));
    }

    return webAppType;
  }

  /**
   * 앱 버전을 체크하는 함수
   * @param userAgent: string
   * @param RegEx: RexExp -> IOS와 AOS 체크 버전이 다르기에 추가
   * @returns { number }
   */
  getVersionType(userAgent: string, RegEx: RegExp): number {
    let version = 0;

    const agent = userAgent.match(RegEx);

    if (agent) {
      version = toNumber(agent[1].replace(/\./g, ''));
    }

    return version;
  }

  getWebAppInfo(userAgent: string): { type: WebAppType; version?: number } {
    if (USER_AGENT_AOS_REG_EX.test(userAgent)) {
      return {
        type: WEBAPP_TYPE_AOS,
        version: this.getVersionType(userAgent, USER_AGENT_AOS_VERSION_REG_EX),
      };
    } else if (USER_AGENT_IOS_REG_EX.test(userAgent)) {
      return {
        type: WEBAPP_TYPE_IOS,
        version: this.getVersionType(userAgent, USER_AGENT_IOS_VERSION_REG_EX),
      };
    } else {
      return { type: WEBAPP_TYPE_WEB };
    }
  }

  static filterLocation({
    latitude,
    longitude,
  }: {
    latitude: number;
    longitude: number;
  }) {
    if (
      latitude > GPS_LATITUDE_MIN &&
      latitude < GPS_LATITUDE_MAX &&
      longitude > GPS_LONGITUDE_MIN &&
      longitude < GPS_LONGITUDE_MAX
    ) {
      return { latitude, longitude };
    } else {
      return {
        latitude: GPS_DEFAULT_LATITUDE,
        longitude: GPS_DEFAULT_LONGITUDE,
      };
    }
  }
}

export default WebAppService;
